import { ToastrService } from 'ngx-toastr';
import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService, EventService, IUser, UserService, EVENTS, GeneralService, TrackingService } from '@clooper/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-profile-modal',
  templateUrl: './edit-profile-modal.component.html',
  styleUrls: ['./edit-profile-modal.component.scss']
})
export class EditProfileModalComponent implements OnInit {

  @Output() getEvent = new EventEmitter();
  @Input() loading = false;
  // @Input() bsModalRef?: BsModalRef;
  countryCodes = [234, 91, 1, 31, 34, 44]; // <- this should not be!
  user: IUser;

  form = new FormGroup({
    id: new FormControl('', [Validators.required]),
    first_name: new FormControl('', [Validators.required]),
    last_name: new FormControl('', [Validators.required]),
    email: new FormControl({ value: '', disabled: true }, [Validators.required]),
    phone: new FormControl('', [Validators.required]),
    // address: new FormControl('')
  })
  constructor(
    public bsModalRef: BsModalService,
    private toastr: ToastrService,
    private userService: UserService,
    private gs: GeneralService,
    @Optional() private eventService: EventService,
    @Optional() private authService: AuthService,
    private tracker: TrackingService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.user = this.authService.getAuthorizedUser()
    this.userService.get(this.user.id, true).subscribe(user => {
      this.user = user
      this.setFormVals()
    })
    this.setFormVals()
  }

  private setFormVals() {
    this.form.patchValue(this.user)
  }

  save() {
    this.loading = true;
    this.userService.update(this.form.value).subscribe((user: any) => {
      // this.toastr.success(user.message)
      this.toastr.success('User updated successfully');
      const data = { route: this.router.url }
      this.tracker.track(EVENTS.UPDATE_USER, data)
      this.eventService.publish(EVENTS.UPDATE_USER, user)
      if (this.user.business) {
        this.eventService.publish(EVENTS.UPDATE_BUSINESS, { business: this.user.business })
      }
      this.bsModalRef.hide();
    }, err => {
      this.toastr.error(this.gs.getErrMsg(err))
    }).add(() => this.loading = false)
  }

}
